import {Component, ElementRef, inject, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {BaseService} from "../../services/base.service";
import {HttpClient} from "@angular/common/http";
import {Meta, Title} from "@angular/platform-browser";
import {ActivatedRoute, Router} from "@angular/router";
import {finalize, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {LocalStorageService} from "../../services/local-storage.service";
import {AccountData, Brand, Calcdebt, userList, Wars} from "../../interfaces/account-data";
import {AccountGoodsData, Photos} from "../../interfaces/account-goods-data";
import {HeaderService} from "../../services/header.service";
import {Delivery} from "../../interfaces/delivery";
import {HeaderComponent} from "../../header/header.component";
import {Clipboard} from '@angular/cdk/clipboard';
import * as moment from "moment";
import {Favorites, FavoritesData} from "../../interfaces/favorites-data";
import {GetBasket} from "../../interfaces/get-basket";
import {GoodsService} from "../../services/goods.service";
import {RequestData} from "../../interfaces/request-data";
import {MenuService} from "../../services/menu.service";
import {CategoriesMenuComponent} from "../../shared/categories-menu/categories-menu.component";
import {Store} from "@ngrx/store";
import {setHaveGoodsStore} from "../../store/have-goods/have-goods.actions";
import {setIncludePartnersStore} from "../../store/include-partners/include-partners.action";
import {ModalNonReturnableItemsComponent} from "./modal-non-returnable-items/modal-non-returnable-items.component";
import {ModalGoodInformationComponent} from "../good/modal-good-information/modal-good-information.component";
import {OrganizationsService} from "../../services/organizations.service";
import {Organization} from "../../interfaces/organization";
import {BuGetBasket, BuGoodsData, BuGoodsParams} from "../../interfaces/bu-goods-data";
import {AssistantActionsService} from "../../services/assistant-actions.service";
import {AssistantHighlight} from "../../shared/assistant-highlight";

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})

export class AccountComponent extends BaseService implements OnDestroy, OnInit {
  @ViewChild('scrollableRef') scrollableRef;
  @ViewChild(HeaderComponent) header: HeaderComponent;
  @ViewChild(CategoriesMenuComponent) categoriesMenuComponentRef: CategoriesMenuComponent;
  @ViewChild(ModalNonReturnableItemsComponent) modalNonReturnableItemsComponentRef: ModalNonReturnableItemsComponent;
  @ViewChild(ModalGoodInformationComponent) modalGoodInformationComponentRef: ModalGoodInformationComponent;

  isDestroyed: Subject<boolean> = new Subject();
  // Обриває незавершені запити товарів за попередніми параметрами (сторінка, категорія, пошук) при новому завантаженні,
  // інакше пізня відповідь старого запиту (напр. повільний AI-пошук) перетирала список під новим URL - як goodsDataReload у good.component
  private goodsDataReload: Subject<void> = new Subject();

  private goodsService: GoodsService = inject(GoodsService);
  private http: HttpClient = inject(HttpClient);
  private titleService: Title = inject(Title);
  private meta: Meta = inject(Meta);
  private router: Router = inject(Router);
  private localStorage: LocalStorageService = inject(LocalStorageService);
  private headerService: HeaderService = inject(HeaderService);
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private clipboard: Clipboard = inject(Clipboard);
  private menuService: MenuService = inject(MenuService);
  private store: Store<{ haveGoodsStore: boolean; includePartnersStore: boolean }> = inject(Store);
  private organizationsService = inject(OrganizationsService);
  private assistantActions = inject(AssistantActionsService);

  // Картка #965: товари, на які вказав помічник, і зняття його обробника
  public highlight = new AssistantHighlight(inject(ElementRef));
  private assistantUnregister: () => void;

  public categoriesSortedDeep = [];
  public brandsSorted: Brand[] = [];
  public categoryHeadShow = '';
  public goods = [];
  public basketData;
  public basketCount: Number;
  public basketSum: Number;
  public isBasketModalShow = false;
  public isDarkBackground = false;
  public favorites: Favorites[] = [];
  public favoritesModalData: {
    name: string, pack_id: any, count: number
  } = {
    name: '',
    pack_id: 0,
    count: 1
  };
  public basketModalData: {
    index: number, name: string, pack_id: number, warehouse: number, count: number, gid: string, sup_wh_id?: number
  } = {
    index: 0,
    name: '',
    pack_id: 0,
    warehouse: 0,
    count: 1,
    gid: null,
    sup_wh_id: null
  };
  // add_basket додає до наявної кількості - подвійний тап у мобільній модалці каталогу клав товар двічі
  public isSendingMobileBasket: boolean = false;
  public currencySubscribe;
  public currencyName;
  public urlParams = {
    page: 1,
    category_id: 0,
    brand_id: 0,
    search: '',
    haveGoods: 0,
    receipt_date: '',
    good_id: 0,
    goods_ids: 0,
    searchMode: 'default',
    includePartners: 0,
    liters: '',
    viscosity: '',
    approvals: '',
    class_api: '',
    class_acea: '',
    class_ilsac: '',
    class_jaso: '',
    composition: '',
  };
  public headCategoryName = '';
  public headCategoryNameColored = 'Головна';
  public subHeadCategoryName = '';
  public calcDebt: Calcdebt;
  public isArticlesShow = false;
  public deliveryInfo: Delivery[];
  public deliveryCurrent: Delivery;
  public wars: Wars[];
  public isAdmin;
  public showPartnerWarehouses: boolean;
  public roleId: number;
  public userListAdmin: userList[];
  public allowLoginUsers: userList[];
  public selectedUserAdmin = 'Користувач не вибраний';
  public selectedUser = 'Користувач не вибраний';
  public isCopyTextShow = false;
  public copyText;
  public isOpenModalPhoto = false;
  public goodName = '';
  public goodPhotos: Photos[];
  public has_cards: boolean;
  public totalItems = 0;
  public maxSize = 5;
  public currentYear: number;
  public isArticleHide = false;
  public goodsData;
  public dataBasket;
  public hide_pagination_max = false;
  public aiSearchError: string = '';
  public userSupper: number;
  private partnersNotShowReturnMessage: boolean;
  private pendingBasket: { id: number, count: number, sup: any, gid: string };
  // Позиції, які зараз кладемо в кошик (захист від подвійного кліку, #515)
  private addingToBasket: {[key: string]: boolean} = {};
  // Товари, які зараз додаємо в обране: сердечко світиться лише після get_favorites, і подвійний
  // клік слав add_to_favorite двічі - бек додає кількість до наявної, в обраному ставало 2
  private addingToFavorite: {[key: string]: boolean} = {};
  private pendingBasketMobile: { id: number, sup: any, name: string, gid: string };
  public isMobileAgreement = false;
  public isFavoriteMessageShow = false;
  private favoriteMessageTimer;
  public favoriteMessage = '';
  public activeOrganization: Organization;
  public isOrganizationsLoaded = false;

  constructor() {
    super();

    const title = 'Маслоточка | Список товарів';
    this.currentYear = moment().year();
    this.titleService.setTitle(title);
    this.meta.addTag({name: 'title', content: title});
    this.meta.addTag({name: 'og:title', content: title});
    this.meta.addTag({name: 'twitter:title', content: title});
    this.meta.addTag({name: 'DC.title', content: title});
  }

  ngOnInit() {
    let currency: string = this.localStorage.get('currencies');

    this.store.select('haveGoodsStore')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(val => {
        this.urlParams.haveGoods = val ? 1 : 0;
      });

    this.store.select('includePartnersStore')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(val => {
        this.urlParams.includePartners = val ? 1 : 0;
      });

    this.currencySubscribe = this.headerService.currency.subscribe((val) => {
      if (currency != val) {
        currency = val;
        this.parseUrlParams(this.activatedRoute.snapshot.queryParams);
        this.getBasket();
      }
    });

    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.getFavorites();
      this.getBasket();

      this.parseUrlParams(params);
    });

    this.organizationsService.organizations$
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((organizations: Organization[]) => {
        if (!organizations || !organizations.length) {
          return;
        }

        this.activeOrganization = organizations.find((org) => org.is_active === '1' || org.is_active === true);

        if (!this.isOrganizationsLoaded) {
          this.isOrganizationsLoaded = true;
          this.getGoodsData();
          this.getBasket();
        }
      });

    // Помічник підсвічує товари списку; товари ще вантажаться (goodsData скинуто) - прокрутка після завантаження
    this.assistantUnregister = this.assistantActions.register('highlight', (action) => {
      this.highlight.set(action.ids);

      if (this.goodsData !== undefined) {
        this.highlight.ready();
      }
    });
  }

  parseUrlParams(params) {
    if (params.page) {
      this.urlParams.page = parseInt(params.page);

      if (params.page === null || params.page <= 0 || isNaN(params.page)) {
        this.urlParams.page = 1;
      }
    } else {
      this.urlParams.page = 1;
    }

    if (params.category_id) {
      this.urlParams.category_id = parseInt(params.category_id);

      if (params.category_id === null || params.category_id < 0 || isNaN(params.category_id)) {
        this.urlParams.category_id = 0;
      }
      this.urlParams.receipt_date = '';
    } else {
      this.urlParams.category_id = 0;
    }

    if (params.brand_id) {
      this.urlParams.brand_id = parseInt(params.brand_id);

      if (params.brand_id === null || params.brand_id < 0 || isNaN(params.brand_id)) {
        this.urlParams.brand_id = 0;
      }
      this.urlParams.receipt_date = '';
    } else {
      this.urlParams.brand_id = 0;
    }

    // з URL приходить рядок: "0" - непорожній, тобто truthy, і фільтр вважався увімкненим
    // (store при цьому вже false і select не емітить, тож виправити значення нікому)
    if (params.haveGoods) {
      this.urlParams.haveGoods = parseInt(params.haveGoods) === 1 ? 1 : 0;
      this.store.dispatch(setHaveGoodsStore({value: parseInt(params.haveGoods) === 1}));
    }

    if (params.includePartners) {
      this.urlParams.includePartners = parseInt(params.includePartners) === 1 ? 1 : 0;
      this.store.dispatch(setIncludePartnersStore({value: parseInt(params.includePartners) === 1}));
    }

    if (params.search) {
      this.urlParams.search = params.search;
      this.urlParams.receipt_date = '';
    } else {
      this.urlParams.search = '';
    }

    if (params.searchMode) {
      this.urlParams.searchMode = params.searchMode;
    } else {
      const saveMode = this.localStorage.get('searchMode');
      this.urlParams.searchMode = saveMode || 'default';
    }

    if (params.receipt_date) {
      this.urlParams.receipt_date = params.receipt_date;
    } else {
      this.urlParams.receipt_date = '';
    }

    if (params.good_id) {
      this.urlParams.good_id = params.good_id;
    } else {
      this.urlParams.good_id = 0;
    }

    if (params.goods_ids) {
      this.urlParams.goods_ids = params.goods_ids;
    } else {
      this.urlParams.goods_ids = 0;
    }

    for (const key of ['liters', 'viscosity', 'approvals', 'class_api', 'class_acea', 'class_ilsac', 'class_jaso', 'composition']) {
      if (params[key]) {
        this.urlParams[key] = params[key];
      } else {
        this.urlParams[key] = '';
      }
    }

    this.getData();
    this.getGoodsData();
  }

  getData() {
    if (this.localStorage.get('delivery_id') === null) {
      return;
    }

    this.http.post(this.apiRoot + 'accounts/data', {
      currency: this.localStorage.get('currencies'),
      delivery_id: this.localStorage.get('delivery_id'),
      page: this.urlParams.page,
      search: this.urlParams.search,
      brand_id: this.urlParams.brand_id,
    })
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: AccountData) => {
        this.userSupper = data.data.user_supper;

        if (data.data.delivery_info) {
          this.wars = data.data.wars;
          this.isAdmin = data.data.is_admin;
          this.showPartnerWarehouses = data.data.show_partner_warehouses;
          this.allowLoginUsers = data.data.allow_login_users;
          this.has_cards = data.data.has_cards;
          this.roleId = data.data.role_id;

          const menuData = this.menuService.buildDataMenu(data, this.urlParams);

          this.headCategoryNameColored = menuData.headCategoryNameColored;
          this.headCategoryName = menuData.headCategoryName;
          this.subHeadCategoryName = menuData.subHeadCategoryName;
          this.userListAdmin = menuData.userListAdmin;
          this.deliveryInfo = menuData.deliveryInfo;
          this.deliveryCurrent = menuData.deliveryCurrent;
          this.selectedUser = menuData.selectedUser;
          this.selectedUserAdmin = menuData.selectedUserAdmin;
          this.categoryHeadShow = menuData.categoryHeadShow;
          this.categoriesSortedDeep = menuData.categoriesSortedDeep;
          this.brandsSorted = menuData.brandsSorted;
          this.calcDebt = menuData.calcDebt;
        }

        if (this.categoriesMenuComponentRef) {
          this.categoriesMenuComponentRef.refreshMenuData(this.categoriesSortedDeep, this.brandsSorted);
        }

        this.buildFavoritesBasket();
      });
  }

  getGoodsData() {
    this.goodsDataReload.next();
    this.goodsData = undefined;

    if (!this.isOrganizationsLoaded) {
      return;
    }

    const isBuOrganization = this.activeOrganization && this.activeOrganization.type !== 'fiz';

    if (isBuOrganization) {
      this.http.post(this.apiRoot + 'bu_goods/get_goods', {
        page: this.urlParams.page,
        category_id: this.urlParams.category_id,
        brand_id: this.urlParams.brand_id,
        search: this.urlParams.search,
        search_exact: this.urlParams.searchMode === 'exact',
        have_goods: this.urlParams.haveGoods ? '1' : null,
        good_id: this.urlParams.good_id,
        goods_ids: this.urlParams.goods_ids,
      })
        .pipe(takeUntil(this.goodsDataReload), takeUntil(this.isDestroyed))
        .subscribe((data: BuGoodsData) => {
          // на виняток бек відповідає success: false без goods - buildBuData падав на goods.length і каталог зникав
          if (!data?.success) {
            this.showGoodsLoadFailed();
            return;
          }

          this.aiSearchError = this.urlParams.searchMode === 'ai' && data.message
            ? data.message
            : '';

          this.goods = data.goods;
          this.hide_pagination_max = data.hide_pagination_max;

          // @ts-ignore
          if (this.goods == 0) {
            this.goods = [];
          }

          this.goodsData = this.goodsService.buildBuData(data, this.urlParams.haveGoods);

          this.totalItems = Number(data.total);

          this.buildFavoritesBasket();

          this.scrollableRef.nativeElement.scrollTo(0, 0);

          this.highlight.ready();
        });
      return;
    }

    if (this.localStorage.get('delivery_id') === null) {
      return;
    }

    this.http.post(this.apiRoot + 'accounts/get_goods', {
      delivery_id: this.localStorage.get('delivery_id'),
      page: this.urlParams.page,
      category_id: this.urlParams.category_id,
      brand_id: this.urlParams.brand_id,
      currency: this.localStorage.get('currencies'),
      search: this.urlParams.search,
      have_goods: this.urlParams.haveGoods,
      include_partners: this.urlParams.includePartners,
      receipt_date: this.urlParams.receipt_date,
      good_id: this.urlParams.good_id,
      goods_ids: this.urlParams.goods_ids,
      search_mode: this.urlParams.searchMode,
      liters: this.urlParams.liters,
      viscosity: this.urlParams.viscosity,
      approvals: this.urlParams.approvals,
      class_api: this.urlParams.class_api,
      class_acea: this.urlParams.class_acea,
      class_ilsac: this.urlParams.class_ilsac,
      class_jaso: this.urlParams.class_jaso,
      composition: this.urlParams.composition,
    })
      .pipe(takeUntil(this.goodsDataReload), takeUntil(this.isDestroyed))
      .subscribe((data: AccountGoodsData) => {
        // success: false - виняток або помилка OpenSearch (сирий текст у message користувачу не показуємо)
        if (!data?.success) {
          this.showGoodsLoadFailed();
          return;
        }

        // Сторінка за межею 10000 результатів OpenSearch: бек віддає лише goods: [] без suppliers,
        // а пагінація пропонує її (total обрізано до 10000) - buildData падав на for...of і каталог зникав
        if (!Array.isArray(data.suppliers)) {
          this.goods = [];
          this.goodsData = [];
          this.aiSearchError = '';
          this.highlight.ready();
          return;
        }

        this.aiSearchError = this.urlParams.searchMode === 'ai' && data.message
          ? data.message
          : '';

        this.goods = data.goods;
        this.hide_pagination_max = data.hide_pagination_max;

        // @ts-ignore
        if (this.goods == 0) {
          this.goods = [];
        }

        this.goodsData = this.goodsService.buildData(data, this.urlParams.haveGoods);

        const pack_ids = this.goodsService.getWaitingPackIds(this.goodsData);

        if (pack_ids.length) {
          this.http.post(this.apiRoot + 'good/get_arrivals_datas', {
            pack_ids,
            delivery_id: this.localStorage.get('delivery_id'),
          })
            .pipe(takeUntil(this.goodsDataReload), takeUntil(this.isDestroyed))
            .subscribe((resp: any) => {
              this.goodsService.applyWaitingExpect(this.goodsData, resp.data);
            });
        }

        this.totalItems = parseInt(data.total);

        this.buildFavoritesBasket();

        this.scrollableRef.nativeElement.scrollTo(0, 0);

        this.highlight.ready();
      });
  }

  // Товари не завантажились: замість порожньої сторінки - блок «нічого не знайдено» з власним текстом
  private showGoodsLoadFailed() {
    this.goods = [];
    this.goodsData = [];
    this.aiSearchError = 'Не вдалося завантажити товари. Оновіть сторінку або спробуйте пізніше.';
    // Рядків немає - прокрутку помічника знімаємо, щоб вона не спрацювала згодом на іншому списку
    this.highlight.ready();
  }

  buildNavigationMenuGoodsData() {
  }

  buildNavigationMenuFavoritesData() {
    this.getFavorites();
  }

  buildNavigationMenuBasketData() {
    this.getBasket();
  }

  buildCategoriesMenuGoodsData() {
    // Товары перезагружает подписка на queryParams (router.navigate в categories-menu) —
    // повторный getGoodsData() здесь задваивал запрос get_goods
  }

  getFavorites() {
    if (this.localStorage.get('delivery_id') === null) {
      return;
    }

    this.http.get(this.apiRoot + 'accounts/get_favorites')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: FavoritesData) => {
        if (data && Array.isArray(data.data)) {
          this.favorites = data.data;
        } else {
          this.favorites = [];
        }

        this.buildFavoritesBasket();
      });
  }

  getBasket() {
    if (!this.isOrganizationsLoaded) {
      return;
    }

    const isBuOrganization = this.activeOrganization && this.activeOrganization.type !== 'fiz';

    if (isBuOrganization) {
      this.basketData = undefined;

      this.http.post(this.apiRoot + 'bu_basket/get_basket', {})
        .pipe(takeUntil(this.isDestroyed))
        .subscribe((data: BuGetBasket) => {
          this.basketData = data.data;

          this.dataBasket = this.menuService.buildBuBasketData(data);

          this.basketSum = this.dataBasket.basketSum.toFixed(2);
          this.basketCount = this.dataBasket.basketCount;
          this.currencyName = this.dataBasket.currencyName;

          this.buildFavoritesBasket();
        });

      return;
    }

    if (this.localStorage.get('delivery_id') === null) {
      return;
    }

    this.basketData = undefined;

    this.http.get(this.apiRoot + 'accounts/get_basket')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: GetBasket) => {
        this.basketData = data.basket_data;
        this.partnersNotShowReturnMessage = data.partners_not_show_return_message;

        const currency_id = this.localStorage.get('currencies');

        this.dataBasket = this.menuService.buildBasketData(data, currency_id);

        this.basketSum = this.dataBasket.basketSum.toFixed(2);
        this.basketCount = this.dataBasket.basketCount;
        this.currencyName = this.dataBasket.currencyName;

        this.buildFavoritesBasket();
      });
  }

  buildFavoritesBasket() {
    if (this.goodsData != undefined && this.basketData != undefined) {
      for (let good of this.goodsData) {
        for (let sup of good.goodsSuppliers) {
          sup.price = Number(sup.price).toFixed(2);
          sup.turnOn = this.basketData ? (!!this.basketData.find(element => {
            // у кошику організації (bu_basket/get_basket) zak_supp_id немає взагалі - рядок свого складу,
            // а з «== 0» undefined йшов у гілку партнера і товар у кошику не підсвічувався
            if (!Number(element.zak_supp_id)) {
              return element.pack_id == good.id && element.warehouse == sup.war;
            } else {
              return element.zak_supp_id == sup.id && element.pack_id == good.id && element.warehouse == sup.war;
            }
          })) : false;
          sup.star = Array.isArray(this.favorites) ? (!!this.favorites.find(element => element.pack_id == good.id)) : false;
        }
      }
    }
  }

  changesPage(event) {
    this.urlParams.page = event;
    this.router.navigate([`account`], {queryParams: this.urlParams});
  }

  brandsMenuShow() {
    this.categoriesMenuComponentRef.brandMenuShow();
  }

  addToBasket(id, count, sup) {
    const gid = sup.gid || null;

    if (sup.partner && !this.partnersNotShowReturnMessage) {

      this.pendingBasket = {id, count, sup, gid};

      this.isMobileAgreement = false;

      this.modalNonReturnableItemsComponentRef.show();
    } else {
      this.sendAddToBasket(id, count, sup, gid);
    }
  }

  sendAddToBasket(id, count, sup, gid) {
    if (sup.partner) {
      id = `z_${sup.id}_${id}`;
    }

    // Подвійний клік «В кошик» клав позицію двічі (#515; у мобільній модалці захист є з #305).
    // Поки запит по цій позиції йде і ще пів секунди від кліку, повтор ігноруємо.
    const addKey = id + '_' + sup.war + '_' + (sup.sup_wh_id || '');

    if (this.addingToBasket[addKey]) {
      return;
    }

    this.addingToBasket[addKey] = true;
    const addStartedAt = Date.now();

    const payload: any = {
      package_id: id,
      count: count,
      warehouse: sup.war,
      delivery: this.localStorage.get('delivery_id'),
      gid: gid
    };

    // Склад партнёра (контракт п.3 с бэком): пока бэк поле не читает — кладёт как раньше, без склада
    if (sup.sup_wh_id) {
      payload.sup_wh_id = sup.sup_wh_id;
    }

    this.http.post(this.apiRoot + 'basket_data/add_basket', payload)
      .pipe(
        takeUntil(this.isDestroyed),
        finalize(() => {
          setTimeout(() => delete this.addingToBasket[addKey], Math.max(0, 500 - (Date.now() - addStartedAt)));
        })
      )
      .subscribe((data: RequestData) => {
        this.goodsService.notifyAddBasketError(data);
        this.getBasket();
      })
  }

  agreeAddToBasket() {
    if (!this.isMobileAgreement && this.pendingBasket) {
      const {id, count, sup, gid} = this.pendingBasket;
      this.sendAddToBasket(id, count, sup, gid);
    } else if (this.isMobileAgreement && this.pendingBasketMobile) {
      const {id, sup, name} = this.pendingBasketMobile;
      this.basketMobileModalShow(id, sup, name);
    }
  }

  agreeNotShowMore() {
    this.http.post(this.apiRoot + 'basket_data/partners_not_show_return_message', {})
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(() => {
        this.agreeAddToBasket();
      });
  }

  addToBasketMobile(id, sup, name) {
    const gid = sup.gid || null;

    if (sup.partner && !this.partnersNotShowReturnMessage) {

      this.pendingBasketMobile = {id, sup, name, gid};

      this.isMobileAgreement = true;

      this.modalNonReturnableItemsComponentRef.show();
    } else {
      this.basketMobileModalShow(id, sup, name);
    }
  }

  basketMobileModalShow(id, sup, name) {
    if (sup.partner) {
      id = `z_${sup.id}_${id}`;
    }

    this.basketModalData.name = name;
    this.basketModalData.pack_id = id;
    this.basketModalData.warehouse = sup.war;
    this.basketModalData.count = 1;
    this.basketModalData.gid = sup.gid || null;
    this.basketModalData.sup_wh_id = sup.sup_wh_id || null;

    this.isBasketModalShow = true;
    this.isDarkBackground = true;
  }

  sendMobileBasket() {
    if (this.isSendingMobileBasket) {
      return;
    }

    const payload: any = {
      package_id: this.basketModalData.pack_id,
      count: this.basketModalData.count,
      warehouse: this.basketModalData.warehouse,
      delivery: this.localStorage.get('delivery_id'),
      gid: this.basketModalData.gid
    };

    if (this.basketModalData.sup_wh_id) {
      payload.sup_wh_id = this.basketModalData.sup_wh_id;
    }

    this.isSendingMobileBasket = true;

    this.http.post(this.apiRoot + 'basket_data/add_basket', payload)
      .pipe(
        takeUntil(this.isDestroyed),
        finalize(() => this.isSendingMobileBasket = false)
      )
      .subscribe((data: RequestData) => {
        this.isBasketModalShow = false;
        this.isDarkBackground = false;

        this.basketModalData.count = 1;
        this.goodsService.notifyAddBasketError(data);
        this.getBasket();
      })
  }

  toggleFavorite(name, id, isFavorite: boolean) {
    if (isFavorite) {
      this.http.post(this.apiRoot + 'favorites/delete', {
        package_id: id
      })
        .pipe(takeUntil(this.isDestroyed))
        .subscribe(() => {
          this.getFavorites();
          this.showFavoriteMessage('Продукт видалено із списку побажань');
        });

      return;
    }

    if (this.addingToFavorite[id]) {
      return;
    }

    this.addingToFavorite[id] = true;
    const addStartedAt = Date.now();

    this.favoritesModalData.name = name;
    this.favoritesModalData.pack_id = id;

    this.http.post(this.apiRoot + 'favorites/add_to_favorite', {
      package_id: this.favoritesModalData.pack_id,
      count: this.favoritesModalData.count
    })
      .pipe(
        takeUntil(this.isDestroyed),
        finalize(() => {
          setTimeout(() => delete this.addingToFavorite[id], Math.max(0, 500 - (Date.now() - addStartedAt)));
        })
      )
      .subscribe(() => {
        this.favoritesModalData.count = 1;

        this.getFavorites();
        this.showFavoriteMessage('Додане в обране.');
      })
  }

  showFavoriteMessage(message: string) {
    this.favoriteMessage = message;
    this.isFavoriteMessageShow = true;

    clearTimeout(this.favoriteMessageTimer);

    this.favoriteMessageTimer = setTimeout(() => {
      this.isFavoriteMessageShow = false;
    }, 2500);
  }

  minusCount(sup) {
    sup.countBasket = parseInt(sup.countBasket) - 1

    if (sup.countBasket < 1) {
      sup.countBasket = 1;
    }
  }

  plusCount(sup) {
    sup.countBasket = parseInt(sup.countBasket) + 1

    if (isNaN(sup.countBasket)) {
      sup.countBasket = 1;
    }
  }

  minusBasketCountGoodModal() {
    this.basketModalData.count -= 1;

    if (this.basketModalData.count === 0) {
      this.basketModalData.count = 1;
    }
  }

  plusBasketCountGoodModal() {
    this.basketModalData.count += 1;
  }

  articlesShow() {
    this.isArticlesShow = true;
  }

  showModalPayment() {
    this.header.modalPaymentChange();
  }

  articleCopy(firstArticle) {
    this.clipboard.copy(firstArticle);

    this.isCopyTextShow = true;

    clearTimeout(this.copyText);
    this.copyText = setTimeout(() => {
      this.isCopyTextShow = false;
    }, 2000)
  }

  packIdCopy(packId: string) {
    this.clipboard.copy(packId);

    this.isCopyTextShow = true;

    clearTimeout(this.copyText);
    this.copyText = setTimeout(() => {
      this.isCopyTextShow = false;
    }, 2000)
  }

  openGoodInfoModal(good_id: number) {
    this.modalGoodInformationComponentRef.openModalGoodInformation(good_id)
  }

  articleBulbCopy(lastArticles, event) {
    event.stopPropagation();
    this.clipboard.copy(lastArticles);

    this.isCopyTextShow = true;
    this.isArticleHide = true;

    clearTimeout(this.copyText);
    setTimeout(() => {
      this.isArticleHide = false;
    }, 20);

    clearTimeout(this.copyText);
    this.copyText = setTimeout(() => {
      this.isCopyTextShow = false;
    }, 2000);
  }

  openModalPhotos(good) {
    this.goodName = good.name
    this.goodPhotos = good.photos

    this.isOpenModalPhoto = true;
    this.isDarkBackground = true;
  }

  notifyInventoryFinished(package_id) {
    this.http.post(this.apiRoot + 'accounts/subscribe_goods_appeared', {
      package_id
    })
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(() => {
        alert('Телеграм бот повідомить вас про закінчення інвентаризації цього товару. Якщо ви підписані на бот.');
      });
  }

  closeModal() {
    this.isBasketModalShow = false;
    this.isOpenModalPhoto = false;
    this.isDarkBackground = false;
  }

  showModalWaitDelivery() {
    this.header.openModalWaitingGoods();
  }

  ngOnDestroy() {
    this.assistantUnregister();
    this.highlight.destroy();
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
    this.currencySubscribe.unsubscribe();
    this.goodsDataReload.complete();
  }
}
